import React from 'react';
import { Loader } from '../Loader';
import { StartSlideV10 } from '../StartSlideV10';
import { StartSlideV12 } from '../StartSlideV12';
import { useABExperiment } from '../../shared/use-ab-experiment';
import styles from './StartSlideV12Experiment.css';

const EXPERIMENT_KEY = 'memory-first-screen-experiment-v50-2';
const EXPERIMENT_USER_PROPERTY = 'memory_first_screen_experiment';

function StartSlideV12Experiment(props) {
    const { isReady, isVariant } = useABExperiment({
        key: EXPERIMENT_KEY,
        userPropertyName: EXPERIMENT_USER_PROPERTY
    });

    if (!isReady) {
        return (
            <div className={styles.loaderContainer}>
                <Loader />
            </div>
        );
    }

    if (!isVariant) {
        return <StartSlideV10 {...props} />;
    }

    return <StartSlideV12 {...props} />;
}

export {
    StartSlideV12Experiment
};
